module.exports = __webpack_public_path__ + "static/media/clv.c62a9c62.png";